"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../../utils/types");
const react_1 = __importStar(require("react"));
const utils_1 = require("../../utils");
const RedeemSectionLoginRequired_1 = __importDefault(require("./RedeemSectionLoginRequired"));
const Message_1 = require("../message/Message");
const PosaRedeemActions_1 = __importDefault(require("../../actions/PosaRedeemActions"));
const RedeemSectionPsnRegionBlocked_1 = __importDefault(require("./RedeemSectionPsnRegionBlocked"));
const RedeemSectionPsnWarning_1 = __importDefault(require("./RedeemSectionPsnWarning"));
const window_or_global_1 = __importDefault(require("window-or-global"));
const PsnConfirmNextSection = ({ externalAuths, connectedPlatforms }) => {
    const psnCountryFromService = react_1.useMemo(() => utils_1.getPsnCountry(externalAuths) || '', [externalAuths]);
    const onClick = react_1.useCallback(() => {
        window_or_global_1.default.scrollTo(0, 0);
        PosaRedeemActions_1.default.setPsnCountry(psnCountryFromService);
        PosaRedeemActions_1.default.setShowConfirm(true);
    }, [psnCountryFromService]);
    const isRegionBlocked = react_1.default.useMemo(() => connectedPlatforms.find(item => {
        return item.platform.toUpperCase() === types_1.PosaPlatforms.PSN && !item.redeemable && !item.regionSupported;
    }), [connectedPlatforms]);
    const isCountryMismatch = react_1.default.useMemo(() => connectedPlatforms.find(item => {
        return item.platform.toUpperCase() === types_1.PosaPlatforms.PSN && !item.redeemable && item.regionSupported;
    }), [connectedPlatforms]);
    if (!psnCountryFromService) {
        return react_1.default.createElement(RedeemSectionLoginRequired_1.default, null);
    }
    if (isRegionBlocked) {
        return react_1.default.createElement(RedeemSectionPsnWarning_1.default, null);
    }
    if (isCountryMismatch) {
        return react_1.default.createElement(RedeemSectionPsnRegionBlocked_1.default, null, Message_1.localizedMessage('epic.code.redemption.posa.page.redeem.regionblocked'));
    }
    return (react_1.default.createElement("div", { className: "confirm-next-section" },
        react_1.default.createElement("button", { onClick: onClick, disabled: !!isCountryMismatch }, Message_1.localizedMessage('epic.code.redemption.posa.page.common.next')),
        react_1.default.createElement("span", null, Message_1.localizedMessage('epic.code.redemption.posa.page.redeem.confirm.next'))));
};
exports.default = PsnConfirmNextSection;
//# sourceMappingURL=RedeemSectionPsnConfirmNext.js.map